export const BUTTON_CLICKED = 'buttonClicked';
export const PAGE_VIEW = 'pageView';
export const LOGIN_COMPLETED = 'loginCompleted';
export const LOGOUT = 'logout';
export const PAYMENT_METHOD_REQUESTED = 'paymentMethodRequested';
export const SIGNUP_WIZARD_STEP_COMPLETED = 'signupWizardStepCompleted';
export const SIGNUP_WIZARD_COMPLETED = 'signupWizardCompleted';
export const REVIEW_PROMPT_SHOWN = 'review_prompt_shown';
export const DEMO_SUGGESTION_SHOWN = 'demo_suggestion_shown';
export const DEMO_SCHEDULED = 'demoScheduled';
export const TRAFFIC_CHECK_COMPLETED = 'traffic_check_completed';
export const DOMAIN_SELECTION_DECISION_MADE = 'domainSelectionDecisionMade';
export const LARGE_CUSTOMER_DECISION_MADE = 'largeCustomerDecisionMade';
